import {classNames, React, StyledProps, withStyles, useLayoutEffect, Fragment, observer} from '@api'
import {
  AssortmentTopToolbarButtons,
  CardViewOptionsToolbarMenu, CatalogSelectionToolbarMenu, CatalogSortByToolbarItems,
  CatalogViewOptionButtons, ExpandCollapseAllGroupsToolbarButtons, GroupByToolbar,
  PerspectiveButtons, SelectAssortmentToolbarButton, StoresInstanceContext, useStores
} from '@design-board/components'
import {PdfDownloadButton} from '@lazy'
import {PdfSidebarToolbarTabs} from '@modules/pdf'
import {globalStores, site} from '@stores'
import {LibrarySidebarTabs, PrimaryIconButton, SubTitleBar, TitleBarControls} from 'centric-ui-components'
import {useMeasure} from 'react-use'
import * as css from './TopBar.css'
import {CustomAttributeDefinition} from '@api/graphql'

const styles = () => ({
  subTitleHeader: {
    borderWidth: 0
  }
})

interface MyProps extends StyledProps {
  onClickOpenSidebar?: (e) => void
  cardViewOptions?: any
  customAttributeDefinitions?: Array<CustomAttributeDefinition>
  onClickMassCreateWithImage?: (e) => void
}

export const TopBarComponent: React.FunctionComponent<MyProps> = (p) => {
  const [ref, {height}] = useMeasure()

  useLayoutEffect(() => {
    if (height != site.sizes.topBar.height) {
      site.sizes.topBar.height = height  // off by 2 pixels???
    }
  }, [height])

  return <div className={css.measurer} ref={ref}>
    <TopBarComponentInternal {...p}/>
  </div>
}

/*
@action clearSelection = () => {
    const {catalog: {selection: {selectedIds}, groupBy: {groupingByName}}} = this.props.stores
    Array.from(groupingByName.values()).forEach(g => g.selected.clear())
    selectedIds.clear()
  }
 */

const TopBarComponentInternal = withStyles(styles)(observer<MyProps>(function TopBarComponentInternal(props) {
  const {classes} = props,
    {
      flexLayout: {activeCatalogRoot, isMaximized, maximizedTab}
    } = globalStores,
    storesToUse = activeCatalogRoot?.stores || globalStores,
    {
      sidebar, isGlobalStore,
      catalog, flexLayout,
      catalog: {isShowingClientPDF, sidebar: {right: {isShowingModal}}}, workspaces: {deploymentConfig, workspaceConfig, view}
    } = storesToUse,
    showToolbarTabs = !isGlobalStore, //activeCatalogRoot != null && view == 'catalog' || workspaceConfig?.library?.tabs?.length > 1,
    modalOverlayShowing = sidebar.right.type === 'modal' && !sidebar.right.inlineModal && sidebar.right.open

  // trace()
  // console.log(`Rerender TopBarComponentInternal()`)

  if (!catalog.isGlobalStore && !catalog.settings.toolbarItems.topToolbar.visible) {
    return null
  }

  // Only show the top bar if we're maximized in a catalog view
  if (!isMaximized || maximizedTab.component != 'catalog') return null
  return (
    <StoresInstanceContext.Provider value={storesToUse}>
      <SubTitleBar
        top={0}
        position='relative'
        data-modal-overlay-showing={modalOverlayShowing}
        data-visible={flexLayout.isMaximized}
        className={classNames(
          css.root,
          {
            [css.rightSidebar]: isMaximized && sidebar.right.open && !isShowingClientPDF,
            [css.leftSidebar]: isMaximized && sidebar.left.open
          })}
        classes={{toolbar: classNames(css.toolbar), header: classes.subTitleHeader}}>
        <TitleBarControls classes={{root: css.titleBarControls}}>
          {showToolbarTabs && <Fragment>
			  <div className={css.sidebarTabs}>
				  <LibrarySidebarTabs/>
			  </div>

			  <div className={css.border}/>
		  </Fragment>
          }

          <div className={css.otherControls}>
            <div className={css.left}>
              {/*<FlexLayoutToolbarItems/>*/}
              {view == 'catalog' &&
			   <Fragment>
				   <div className={css.groupBy}>
					   <GroupByToolbar key={storesToUse?.storeId} className={css.groupByToolbar}/>
				   </div>
			   </Fragment>}
            </div>

            <div className={css.right}>
              <CatalogToolbarItems isInTopBar/>
            </div>
          </div>
        </TitleBarControls>
      </SubTitleBar>
    </StoresInstanceContext.Provider>
  )
}))

export const CatalogToolbarItems = observer<{ isInTopBar?: boolean }>(function CatalogToolbarItems({isInTopBar}) {
  const {flexLayout: {showCatalogWidgetsInTopBar, isMaximized, flexEnabled}, catalog, catalog: {canShowAssortment, isShowingAssortment, settings: {viewMode, toolbarItems}, workspaceConfig, isShowingClientPDF, showTable, isProductView}, pdf, isGlobalStore} = useStores()

  return (
    <Fragment>
      { /*!filterChipsToolbar.isShowing && */ <PerspectiveButtons/>}

      {/*<MediaQuery minWidth={ui.constants.MIN_WIDTH_FOR_SORT_IN_TOOLBAR}>*/}

      {/*isInTopBar && */(toolbarItems.viewOptions &&
	                      <div className={css.cardViewToolbarMenu}>
		                      <CardViewOptionsToolbarMenu key={workspaceConfig?._id}/>
	                      </div>)}

      {/*isInTopBar && */<div style={{borderRight: 'none'}} className={css.sortBy}>
        <CatalogSortByToolbarItems/>
      </div>}

      {isShowingClientPDF ?
       <React.Suspense fallback={<div/>}>
         <div>
           <PdfDownloadButton/>
         </div>
         {<CatalogViewOptionButtons isInTopBar={isInTopBar}/>}
         {(!flexEnabled || isMaximized) &&
		  <div className={css.sidebarTabs}>
			  <PdfSidebarToolbarTabs/>
		  </div>}
       </React.Suspense> : <Fragment>
         {<CatalogViewOptionButtons isInTopBar={isInTopBar}/>}
         {<CatalogSelectionToolbarMenu/>}
         <AssortmentTopToolbarButtons/>
         <ExpandCollapseAllGroupsToolbarButtons/>
       </Fragment>}
    </Fragment>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/topBar/components/TopBar.tsx